export class Result<T, E> {
  private constructor(
    private readonly _value?: T,
    private readonly _error?: E,
    private readonly _isSuccess: boolean = true
  ) {}

  static success<T, E = never>(value: T): Result<T, E> {
    return new Result<T, E>(value, undefined, true)
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static failure<T = never, E = any>(error: E): Result<T, E> {
    return new Result<T, E>(undefined, error, false)
  }

  get isSuccess(): boolean {
    return this._isSuccess
  }

  get isFailure(): boolean {
    return !this._isSuccess
  }

  get value(): T {
    if (this.isFailure) {
      throw new Error('Cannot get the value of a failed result.')
    }
    return this._value as T
  }

  get error(): E {
    if (this.isSuccess) {
      throw new Error('Cannot get the error of a successful result.')
    }
    return this._error as E
  }
}
